import { jsx as _jsx } from "react/jsx-runtime";
import { Presence as RadixPresence } from '@radix-ui/react-presence';
import { cloneElement, useCallback, useEffect, useRef, useState, } from 'react';
const setRef = (ref, node) => {
    if (typeof ref === 'function')
        ref(node);
    else if (ref)
        ref.current = node;
};
/**
 * Keeps a conditionally rendered element mounted until its exit animation
 * ends. Use it instead of a timer; for an exit that is a CSS transition, use
 * `useExitComplete`.
 */
export function Presence({ present, children, onExitComplete }) {
    const [node, setNode] = useState(null);
    const hasMountedRef = useRef(false);
    const childRef = children.props.ref;
    const trackNode = useCallback((element) => {
        setNode(element);
        setRef(childRef, element);
    }, [childRef]);
    useEffect(() => {
        if (node) {
            hasMountedRef.current = true;
            return;
        }
        if (!hasMountedRef.current)
            return;
        hasMountedRef.current = false;
        onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete();
    }, [node, onExitComplete]);
    return (_jsx(RadixPresence, { present: present, children: onExitComplete ? cloneElement(children, { ref: trackNode }) : children }));
}
